import { render, staticRenderFns } from "./EducationOverview.vue?vue&type=template&id=1429452a"
import script from "./EducationOverview.vue?vue&type=script&lang=js"
export * from "./EducationOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports